export const MyAccount = {'en-EN': "My account", 'fr-FR': "Mon compte", 'pt-PT':"A minha conta"};
export const ServicesApps = {'en-EN': "Services & Applications", 'fr-FR':"Services & Applications", 'pt-PT':"Serviços e Aplicações"};
export const Help = {'en-EN':"Help", 'fr-FR':"Aide", 'pt-PT':"Ajuda"};
export const Logout = {'en-EN':"Logout", 'fr-FR':"Déconnexion", 'pt-PT':"Sair"};
